<script lang="ts">
	import type { HTMLAttributes } from "svelte/elements";
	import { cn, type WithElementRef } from "$lib/utils.js";

	let {
		ref = $bindable(null),
		class: className,
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLElement>> = $props();
</script>

<div
	bind:this={ref}
	data-slot="sidebar-content"
	data-sidebar="content"
	class={cn(
		"flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
		"scrollbar-thin scrollbar-thumb-latte-surface1 scrollbar-track-latte-mantle dark:scrollbar-thumb-macchiato-surface1 dark:scrollbar-track-macchiato-crust",
		className
	)}
	{...restProps}
>
	{@render children?.()}
</div>
